<dgx-components-panel
  class="contact-us-panel"
  highlight="primary"
  highlightPosition="top"
>
  <div class="contact-us-panel__inner">
    <dgx-components-icon
      *ngIf="icon"
      [icon]="icon"
      [size]="'lg'"
      class="contact-us-panel__icon"
    />

    <h3 class="contact-us-panel__title">{{ title }}</h3>

    <dgx-components-link
      *ngIf="link"
      [href]="link.href"
      [newWindow]="link.newWindow === true"
      [routerPath]="link.routerPath"
      class="contact-us-panel__link"
    >
      {{ link.label }}
    </dgx-components-link>

    <dgx-components-rich-text
      *ngIf="body"
      [content]="body"
      [spacing]="'sm'"
      class="contact-us-panel__body"
    />
  </div>
</dgx-components-panel>
